export const appStr = {
  txt_001: 'search',
  txt_002: 'full_name',
  txt_003: 'total_hour',
  txt_004: 'total_km',
  txt_005: 'teacher_code',
  txt_006: 'student_code',
  txt_007: 'created',
  txt_008: 'folder_name',
  txt_009: 'total_files',
  txt_010: 'update',
  txt_011: 'finish',
  txt_012: 'nav_dashboard',
  txt_013: 'shift_distance_km',
  txt_014: 'shift_hours',
  txt_015: 'at_hours',
  txt_016: 'night_hours',
  txt_017: 'distance_km_learned',
  txt_018: 'time_learned',
  txt_019: 'course_code',
  txt_020: 'phone_number',
  txt_021: 'place_working',
  txt_022: 'birthday',
  txt_023: 'course',
  txt_024: 'order_code',
  txt_025: 'order_status',
  txt_026: 'slot_day',
  txt_027: 'slot_time',
  txt_028: 'scheduler',
  txt_029: 'group',
  txt_030: 'date_time',
  txt_031: 'add',
  txt_032: 'student_name',
  txt_033: 'teacher_name',
  txt_034: 'plate_number',
  txt_035: 'search_fuel_date',
  txt_036: 'quantity',
  txt_037: 'search_place_working',
  txt_038: 'tms_time_in',
  txt_039: 'tms_time_out',
  txt_040: 'search_plate',
  txt_041: 'search_repair_date',
  txt_042: 'repair_term',
  txt_043: 'price',
  txt_044: 'account',
  txt_045: 'information',
  txt_046: 'password',
  txt_047: 'choose',
  txt_048: 'change',
  txt_049: 'tms_checkin_name',
  txt_050: 'edit',
  txt_051: 'save',
  txt_052: 'username_is_required',
  txt_053: 'password_is_required',
  txt_054: 'atkm',
  txt_055: 'tms_checkin_car',
  txt_056: 'tms_checkout_car',
  txt_057: 'car_number',
  txt_058: 'car_brand',
  txt_059: 'code',
  txt_060: 'partner_name',
  txt_061: 'group_name',
  txt_062: 'summary',
  txt_063: 'search_card',
  txt_064: 'search_bill',
  txt_065: 'search_tms_date',
  txt_066: 'statistic',
  txt_067: 'car_assigned',
  txt_068: 'search_by_date',
  txt_069: 'card_number',
  txt_070: 'search_repair_date',
  txt_071: 'primary_code',
  txt_072: 'secondary_code',
  txt_073: 'degree',
  txt_074: 'tracking',
  txt_075: 'ticket_type',
};
